import { isEqual, isNil, isObject, isString } from 'lodash';
import { EditableField, Field } from './Field';

export interface Subform {
  workflowTemplateId: string;
  data: Record<string, any>;
}

export class SubformField implements EditableField {
  readonly subform: Subform;
  readonly workflowTemplate?: MBAPI.WorkflowTemplate | undefined;
  readonly fieldType = 'SubformField';

  constructor(
    subform: Subform,
    workflowTemplateRefs?: MBAPI.ListWorkflowEntitiesQuery_list_refs_workflowTemplateRefs[] | null,
  ) {
    this.subform = subform;
    this.workflowTemplate = workflowTemplateRefs?.find(w => w.id === subform?.workflowTemplateId);
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof SubformField && isEqual(this.subform, field.subform);
  }

  toFieldJson() {
    return this.subform;
  }

  get isEmpty() {
    return isNil(this.subform?.workflowTemplateId);
  }

  static fromFieldJson(
    jsonBlob: MBAPI.Scalar.JSON,
    workflowTemplateRefs?: MBAPI.ListWorkflowEntitiesQuery_list_refs_workflowTemplateRefs[] | null,
  ): SubformField | null {
    if (isSubform(jsonBlob)) {
      return new SubformField(jsonBlob, workflowTemplateRefs);
    } else {
      return null;
    }
  }
}

function isSubform(jsonBlob: MBAPI.Scalar.JSON): jsonBlob is Subform {
  return !isNil(jsonBlob) && isString(jsonBlob.workflowTemplateId) && isObject(jsonBlob.data);
}
